import OrganizationGroupsSelect from './OrganizationGroupsSelect'
export default OrganizationGroupsSelect
